import React from "react";
import s from "./SearchDestinations.css";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import search from "../../../../public/SiteIcons/search.svg";
import messages from "../../../locale/messages";
import { FormattedMessage } from "react-intl";
import { injectIntl } from "react-intl";
import SearchForm from "../SearchForm/SearchForm";

class SearchDestinations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
    };
  }

  handleChange = (e) => {
    this.setState({ query: e.target.value });
  };

  handleSearch = () => {
    alert(`Searching for: ${this.state.query}`);
  };

  render() {
    return (
      <div className={s.searchSection}>
        <h2 className={s.heading}>
          <FormattedMessage {...messages.searchDestinations} />
        </h2>
        <div className={`${s.searchBox} homeBotomSearch`}>
          <SearchForm id={"home_search"} allSearch={false} />
        </div>
      </div>
    );
  }
}

export default injectIntl(withStyles(s)(SearchDestinations));
